import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axios-base-query';

import { envVar } from '~/constants';

const { PYTHON_API_PREFIX } = envVar();

interface StartPythonTaskResponse {
  taskId: string;
}

interface PythonTaskStatusResponse {
  /**
   * celery built-in states
   * https://docs.celeryq.dev/en/stable/userguide/tasks.html?highlight=STARTED#built-in-states
   */
  state:
    | 'PENDING'
    | 'STARTED'
    | 'SUCCESS'
    | 'FAILURE'
    | 'RETRY'
    | 'REVOKED'
    | 'PROGRESS';
  task: {
    progress: string;
    /**
     * May carry other properties depending on the task being run
     */
    result: any;
  };
}

interface RemovePythonTaskResponse {
  taskId: string;
}

export const pythonTaskApi = createApi({
  reducerPath: 'pythonTaskApi',
  baseQuery: axiosBaseQuery({ baseUrl: `${PYTHON_API_PREFIX}/task` }),
  endpoints: (builder) => ({
    start: builder.mutation<StartPythonTaskResponse, unknown>({
      query: (data) => ({
        url: '/v1/sample',
        method: 'post',
        data,
      }),
    }),
    status: builder.query<PythonTaskStatusResponse, string>({
      query: (taskId) => ({
        url: `/v1/status/${taskId}`,
        method: 'get',
      }),
    }),
    cancel: builder.mutation<RemovePythonTaskResponse, string>({
      query: (taskId) => ({
        url: `/v1/id/${taskId}`,
        method: 'delete',
      }),
    }),
  }),
});
